/**
 * Bilibili Hashtag 热搜榜 - 常量配置
 */
import moment from 'moment';

/** 全天 24 小时列表 (0~23) */
export const ALL_HOURS: string[] = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, '0'),
);

/**
 * 获取最近 n 小时的时段列表（基于 UTC+8 当前时间回溯）
 * 返回正序（从小到大），由 BilibiliHashtagTable 统一做 reverse 展示倒序表头
 */
export function getRecentHours(n: number): string[] {
  const utc8Hour = moment().utcOffset(8).hour();
  const hours: string[] = [];
  for (let i = 0; i < n; i++) {
    const h = (utc8Hour - i + 24) % 24;
    hours.push(String(h).padStart(2, '0'));
  }
  // 返回正序，与 ALL_HOURS 保持一致，由表格组件统一 reverse
  return hours.reverse();
}

/**
 * 获取 UTC+8 当天的日期范围
 * 近N小时模式下用于替换 FilterCommon 的日期筛选，固定为当天 00:00:00 ~ 23:59:59
 */
export function getUtc8TodayRange(): { start_time: string; end_time: string } {
  const today = moment().utcOffset(8);
  return {
    start_time: today.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end_time: today.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  };
}

/** 快捷时段选项 */
export interface IQuickOption {
  key: string;
  label?: string;
  getHours: () => string[];
}

export const QUICK_OPTIONS: IQuickOption[] = [
  { key: 'all', label: 'All Time', getHours: () => ALL_HOURS },
  { key: '4', getHours: () => getRecentHours(4) },
  { key: '6', getHours: () => getRecentHours(6) },
  { key: '8', getHours: () => getRecentHours(8) },
];

/** 热搜标签颜色映射 */
export const TAG_COLOR_MAP: Record<string, { bg: string; color: string }> = {
  '热': { bg: '#FFF1F0', color: '#FF4D4F' },
  '新': { bg: '#F6FFED', color: '#52C41A' },
  '首发': { bg: '#E6F7FF', color: '#1890FF' },
  '梗': { bg: '#F9F0FF', color: '#722ED1' },
  '夜': { bg: '#E6FFFB', color: '#13C2C2' },
};

/** Bilibili Hashtag 数据项类型（扁平化后的结构，供表格使用） */
export interface IBilibiliHashtagItem {
  rank: number;
  hashtag: string;
  hashtag_en: string;
  trending_label: string;
  tag_icon: string;
  time: string;
}
